import { invariantResponse } from '@epic-web/invariant'
import { formatDistanceToNow } from 'date-fns'
import { type LoaderFunctionArgs, data } from 'react-router'
import DocumentComponent from '#app/routes/_app+/documents+/__mdx.tsx'
import { reader } from '#app/utils/keystatic-reader.server'
import { parseMdx } from '#app/utils/mdx-bundler.server'

export async function loader({ params: { type } }: LoaderFunctionArgs) {
	invariantResponse(type, `Type param required`, { status: 400 })
	const document = await reader.collections.schedules.read(type, {
		resolveLinkedFiles: true,
	})
	invariantResponse(document, `No post matching slug: ${type}`)

	const date = new Date(document.publishedOn)
	const timeAgo = formatDistanceToNow(date)

	const { code: mdx } = await parseMdx(document.content)
	invariantResponse(mdx, `Error parsing MDX file.`, { status: 404 })

	return data({ type, document, mdx, timeAgo })
}

export default DocumentComponent
